const getUnitId = (unit) => unit?.id;

const getUnitMacAddress = (unit) => unit?.esp32_mac_address;

export const unitParamMap = {
  battery: getUnitId,
  usage: getUnitMacAddress,
  location: getUnitMacAddress,
  waterChanges: getUnitMacAddress,
  // Add another cases here
};
